"use strict";

const style = require("!!css-loader!./style/index.css").default;

module.exports = `
    <style>${style}</style>
    <div class="swiftref-split-toggle" role="radiogroup" aria-label="Toggle">
        <button type="button" class="swiftref-split-toggle__half swiftref-split-toggle__half--left">Off</button>
        <button type="button" class="swiftref-split-toggle__half swiftref-split-toggle__half--right">On</button>
    </div>
    <swiftref-message state="error"></swiftref-message>
`;
